import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { rowInjectionKey as m } from "./Row.js";
import { throwError as p } from "../../_utils/naive/warn.js";
import { formatLength as u } from "../../_utils/css/format-length.js";
import { defineComponent as d, inject as a, computed as n, h as s } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const c = {
  span: {
    type: [String, Number],
    default: 1
  },
  push: {
    type: [String, Number],
    default: 0
  },
  pull: {
    type: [String, Number],
    default: 0
  },
  offset: {
    type: [String, Number],
    default: 0
  }
}, P = d({
  name: "Col",
  props: c,
  setup(t) {
    const e = a(m, null);
    return e || p("col", "`n-col` must be placed inside `n-row`."), {
      mergedClsPrefix: e.mergedClsPrefixRef,
      gutter: e.gutterRef,
      stylePadding: n(() => `${u(e.verticalGutterRef.value, {
        c: 0.5
      })} ${u(e.horizontalGutterRef.value, {
        c: 0.5
      })}`),
      mergedPush: n(() => Number(t.push) - Number(t.pull))
    };
  },
  render() {
    const {
      $slots: t,
      span: e,
      mergedPush: o,
      offset: l,
      stylePadding: i,
      gutter: f,
      mergedClsPrefix: r
    } = this;
    return s("div", {
      class: [`${r}-col`, {
        [`${r}-col--${e}-span`]: !0,
        [`${r}-col--${o}-push`]: o > 0,
        [`${r}-col--${-o}-pull`]: o < 0,
        [`${r}-col--${l}-offset`]: l
      }],
      style: {
        padding: i
      }
    }, f ? s("div", null, t) : t);
  }
});
export {
  c as colProps,
  P as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/legacy-grid/src/Col.js
// module id = 107
// module chunks = 41